<template>
    <div class="mileage-info">
        <div class="info-header" @click="changeState('isMileageInfoShow')">
            <div class="info-header-left">
                <span class="info-header-block"></span>
                <span class="info-header-text">里程信息</span>
            </div>
            <i :class="['el-icon', 'mgr-10', isMileageInfoShow ? 'el-icon-arrow-down' :'el-icon-arrow-right']"></i>
        </div>
        <div class="mileage-wrapper" v-show="isMileageInfoShow">
            <el-form label-position="left" label-width="130px">
                <el-row :gutter="2">
                    <el-col :span="6">
                        <el-form-item label="总里程(km):">
                            <span @dblclick="copyText($event)">{{ formateValue(basicInfo.totalMileage) }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="装货补贴里程(km):">
                            <span @dblclick="copyText($event)">{{ formateValue(basicInfo.loadSubsidyMileage) }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="串点里程(km):">
                            <span @dblclick="copyText($event)">{{ formateValue(basicInfo.subsidyMileage) }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="串点数:">
                            <span @dblclick="copyText($event)">{{ formateValue(basicInfo.pointsNumber) }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="卸货补贴里程(km):">
                            <span @dblclick="copyText($event)">{{ formateValue(basicInfo.unloadSubsidyMileage) }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="提货补贴里程(km):">
                            <span @dblclick="copyText($event)">{{ formateValue(basicInfo.loadSubsidyMileage) }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="配送导航里程(km):">
                            <span @dblclick="copyText($event)">{{ formateValue(basicInfo.subsidyMileage + basicInfo.unloadSubsidyMileage) }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="返程里程(km):">
                            <span @dblclick="copyText($event)">{{ formateValue(basicInfo.backMileage) }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="运输里程(高德)(km):">
                            <span @dblclick="copyText($event)">{{ formateValue(basicInfo.amapMileage) }}</span>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <mileage-detail
                v-if="calculationType !== 3"
                :mileageDetailData="mileageDetailData"
                :calculationType="calculationType"
            ></mileage-detail>
        </div>
    </div>
</template>

<script>
import { copyToClip } from '../util.js';
import MileageDetail from './MileageDetail';
export default {
    name: 'MileageInformation',
    components: { MileageDetail },
    props: {
        basicInfo: {
            type: Object,
            default () {
                return {};
            }
        },
        calculationType: {
            type: Number,
            default () {
                return 0;
            }
        },
        mileageDetailData: {
            type: Array,
            default () {
                return [];
            }
        }
    },
    data () {
        return {
            isMileageInfoShow: true
        };
    },
    computed: {
        formateValue () {
            return function (val) {
                return (val !== null && val !== undefined && val !== '') ? val : '--';
            };
        }
    },
    methods: {
        changeState (state) {
            this[state] = !this[state];
        },
        /**
         * @description 双击复制
         * @param {*} e
         */
        copyText (e) {
            const value = (e.target.innerHTML).trim();
            value !== '--' && copyToClip(value);
        }
    }
};
</script>

<style lang="less" scoped>
@import '../dispatchInfoDetail.less';
.mileage-info {
    background-color: #fff;
    margin-bottom: 10px;
}
.mileage-wrapper {
    padding: 10px 0px 10px 20px;
}
</style>
